module.exports = __webpack_public_path__ + "static/media/AWS-MachineLearning-Specialty-2020.b750bb1a.png";